import { Component, Prop, Emit, Vue, Mixins, Watch } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import SBAPI from '@/util/SBAPI';
import { ArtistTypeEnum, ArtistPageTypeEnum } from '@/generated/api';
import { isAxiosError, AxiosErrorHandler } from '@/util/AxiosErrorHandler';
import { fi } from 'date-fns/locale';

@Component({
    components: AllComponents(),
})
export default class Artist extends Mixins(CommonView) {

    public slug: string = "";
    public artist: SBAPI.Artist = SBAPI.artist();
    public artistList: SBAPI.Artist[] | null = [];
    public type: ArtistPageTypeEnum = ArtistPageTypeEnum.NORMAL;
    kurukuru: boolean = false;
    public snsCount: number = 3;

    public now: Date = new Date;

    public async created() {
        await this.init();
    }

    @Watch('$route')
    public async init() {
        this.slug = this.$route.params.slug;
        this.kurukuru = true;
        if (this.$route.params.no) {
            if (this.$route.params.no === "Kaida_Nagao_Genzuki") {
                this.$router.push("/lineup/Kaida_Nagao_Genzuki");
            }
        }
        let responseArtist = await SBAPI.ArtistController.getArtistUsingGET(this.slug, <any>this.$route.query.state)
        if (responseArtist.status == 200) {
            this.artist = responseArtist.data;
            document.title = this.artist.name + " - サプライズボックス（SURPRISEBOX） - あなたの応援がサプライズで返ってくる";

            if (this.artist.pageType !== ArtistPageTypeEnum.NORMAL && this.artist.pageType !== ArtistPageTypeEnum.NORMAL2) {
                let res = await SBAPI.ArtistController.getArtistByTagUsingGET(this.slug).catch(AxiosErrorHandler);
                if (!isAxiosError(res)) {
                    this.artistList = res.data;
                    this.type = this.artist.pageType!;
                }
            } else {
                this.type = ArtistPageTypeEnum.NORMAL;
                this.artistList = [];
            }
            this.now = new Date(responseArtist.headers.date);
        } else {
            this.$router.push("/");
        }
        this.kurukuru = false;
    }

    public async clickButton(planId: string) {
        this.$router.push("/lineup/" + this.artist.slug + "/plan/" + planId + "/checkout");
    }

    public async snsDetail() {
        if (this.snsCount == 3) {
            this.snsCount = 100;
        } else {
            this.snsCount = 3;
        }
    }

}


